import i18n from "../../i18n";
import axios from "axios";
import { isReadOnly } from "../../utils/userAuthz";

const actions = {
  async getWorkplace(context) {
    try {
      const r = await axios.get("workplace");
      // якщо бекенд повертає { data: [...] }
      const list = Array.isArray(r.data?.data) ? r.data.data : r.data;
      const first = Array.isArray(list) ? list[0] : list;
      return first || null;
    } catch (e) {
      context.dispatch("triggerError", e);
      return null;
    }
  },

  createWorkplace(context, value) {
    if (isReadOnly()) return Promise.resolve(null);
    return axios
      .post("workplace", value)
      .then((r) => r.data)
      .catch((e) => {
        context.dispatch("triggerError", e);
      });
  },

  updateWorkplace(context, value) {
    if (isReadOnly()) return Promise.resolve(null);
    return axios
      .put("workplace/" + value.id, value)
      .then((r) => r.data)
      .catch((e) => {
        context.dispatch("triggerError", e);
      });
  },
  deleteWorkplace(context, val) {
    return axios
      .delete("workplace/" + val.id)
      .then(function (res) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("snackbars.operatingInstructionDeleted")
        );
        return res;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getSingleWorkplace(context, id) {
    return axios
      .get("workplace/" + id)
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },
};

export default actions;
